module.exports = __webpack_public_path__ + "img/DMD-alt.3f49a171.svg";